import { render, staticRenderFns } from "./ChatOrderHistoryCard.vue?vue&type=template&id=5defb320&scoped=true&"
import script from "./ChatOrderHistoryCard.vue?vue&type=script&lang=js&"
export * from "./ChatOrderHistoryCard.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderHistoryCard.vue?vue&type=style&index=0&id=5defb320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5defb320",
  null
  
)

export default component.exports